import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Activity from './pages/Activity'
import Report from './outputs/Report'
import Login from "./pages/Login"
import Home from './pages/Home'
import Error from './pages/Error'
import FilePage from './outputs/FilePage'
import FolderPage from './outputs/FolderPage'
import AdminPage from './pages/Admin'
import ProjectsPage from './outputs/ProjectsPage'
import ZonesPage from './outputs/ZonesPage'
import ChemicalPage from './outputs/ChemicalPage'
import ActionPage from './outputs/ActionPage'
import TypePage from './outputs/TypePage'
import WeedPage from './outputs/WeedPage'
import { createTheme,ThemeProvider } from '@mui/material'

const theme = createTheme({
	palette:{
		primary:{
			main:"#1D68AA"
		}
	}
});

export default function App()
{
	return (
		<ThemeProvider theme={theme}>
		<Routes>
			<Route path="/activity/:project/:zone" element={<Activity />} />
			<Route path="/home" element={<Home />}>
				<Route index element={<FilePage />} />
				<Route path="activities" element={<FilePage />} />
				<Route path="project/:projectName" element={<FolderPage />} />
				<Route path='project/:projectName/zone/:zoneName' element={<FilePage />} />
				<Route path="report/:id" element={<Report />} />
			</Route>
			<Route path="/login" element={<Login />} />
			<Route path='/' element={<Navigate to="/login" />} />
			<Route path="*" element={<Error />} />
			<Route path="/admin" element={<AdminPage />}>
				<Route path="projects"  element={<ProjectsPage/>} />
				<Route path="zones"     element={<ZonesPage/>} />
				<Route path="chemicals" element={<ChemicalPage/>} />
				<Route path="actions"   element={<ActionPage/>} />
				<Route path="types"     element={<TypePage/>} />
				<Route path="weeds"     element={<WeedPage/>} />
			</Route>
		</Routes>
		</ThemeProvider>
	)
}
